import {Box, Text} from 'platform/foundation';

import {TestIdProps} from 'shared/web';

/** White text at this opacity stays readable (above 4.5:1) on the dark card. */
const MUTED_TEXT_OPACITY = 0.75;

interface MutedTextProps extends TestIdProps {
  children: string;
}

/** Small secondary text on the dark price card. */
export function MutedText(props: MutedTextProps) {
  return (
    <Box opacity={MUTED_TEXT_OPACITY}>
      <Text size="xSmall" color="white" data-testid={props['data-testid']}>
        {props.children}
      </Text>
    </Box>
  );
}
